import certificate1 from "../../assests/certificate-1.jpg";
import certificate2 from "../../assests/certificate-2.jpg";
import certificate3 from "../../assests/certificate-3.jpg";
import certificate4 from "../../assests/certificate-3.jpeg";
import certificate5 from "../../assests/certificate-5.jpeg";
import certificate6 from "../../assests/certificate-6.jpg";
import certificate7 from "../../assests/certificate-7.jpg";
import certificate8 from "../../assests/certificate-8.jpg";
import certificate9 from "../../assests/certificate-9.jpg";
import Apperication1 from "../../assests/Apperication1.jpg";
import achivement1 from "../../assests/achivements1.jpeg";
import achivement2 from "../../assests/achivements2.jpeg";
import achivement3 from "../../assests/achivements3.jpeg";
import achivement4 from "../../assests/achievements4.jpeg";

const Menu = [
    {
      id: 1,
      image: certificate1,
      title: "DevOps Beginners to Advanced with Projects",
      category: "Certifications",
      instructor: "Imran Teli",
      date: "23 Jan 2025",
      duration: "54.5 total hours",
      issuer: "Udemy",
      description: "Comprehensive DevOps course covering CI/CD, Docker, Kubernetes, and cloud platforms"
    },
    {
      id: 2,
      image: certificate4,
      title: "AWS Certified Developer - Associate",
      category: "Certifications",
      validationNumber: "7e42b2a4efec4f45b0705b9a2752826e",
      date: "September 21, 2024",
      expirationDate: "September 21, 2027",
      issuer: "AWS",
      description: "AWS Certified Developer certification demonstrating expertise in developing and maintaining applications on AWS"
    },
    {
      id: 3,
      image: certificate3,
      title: "Docker & Kubernetes: The Practical Guide [AWS Platform]",
      category: "Certifications",
      instructor: "Shikhar Verma",
      date: "27 Apr 2024",
      duration: "15.5 total hours",
      issuer: "Udemy",
      description: "Hands-on guide to containerization with Docker and orchestration with Kubernetes on AWS"
    },
    {
      id: 4,
      image: certificate2,
      title: "Ultimate AWS Certified Developer Associate DVA-C02",
      category: "Certifications",
      instructor: "Stephane Maarek",
      date: "May 2024",
      duration: "30+ hours",
      issuer: "Udemy",
      description: "In-depth preparation for AWS Developer Associate certification covering all exam topics"
    },
    {
      id: 5,
      image: certificate5,
      title: "Adobe Certified Professional - Adobe Commerce Developer",
      category: "Certifications",
      date: "2024",
      issuer: "Adobe",
      description: "Professional certification in Adobe Commerce (Magento) development"
    },
    {
      id: 6,
      image: certificate6,
      title: "Microservices: Designing Highly Scalable Systems",
      category: "Certifications",
      instructor: "Sean Campbell",
      date: "7 Nov 2025",
      duration: "1.5 total hours",
      issuer: "Udemy",
      certificateNumber: "UC-57c99825-d3a9-435c-bec7-3825d48cb855",
      certificateUrl: "ude.my/UC-57c99825-d3a9-435c-bec7-3825d48cb855",
      referenceNumber: "0004",
      description: "Comprehensive course on designing microservices architecture and building highly scalable distributed systems"
    },
    {
      id: 7,
      image: certificate7,
      title: "Certificate of Appreciation - Brown Bag Session Speaker",
      category: "Appreciations",
      date: "2024",
      issuer: "Bajaj Finserv Direct Limited",
      awardedBy: "Dhiraj Jha, Head-Consulting Services",
      description: "In recognition of valuable contribution as a Brown Bag Session speaker powered by Adobe/DXC Practice. Dedication and expertise have enriched employees, fostering learning and growth."
    },
    {
      id: 8,
      image: certificate8,
      title: "Best Team of the Quarter - Q2 FY-25",
      category: "Appreciations",
      date: "Q2 FY-25",
      issuer: "Bajaj Technology Services",
      awardedBy: "Narayan Iyer (President) & Shashidhar Bhat (Chief Practice Officer)",
      description: "Presented for outstanding performance and achievements, displaying exceptional teamwork and dedication in Q2 FY-25"
    },
    {
      id: 9,
      image: certificate9,
      title: "Thank You for Your Contribution",
      category: "Appreciations",
      date: "2024",
      issuer: "Bajaj Technology Services",
      awardedBy: "Deepak Nayar (Head - HR) & Narayan Iyer (President)",
      description: "Presented for valuable efforts and contribution to the project at Bajaj Technology Services"
    },
    {
      id: 10,
      image: Apperication1,
      title: "Learning and Development Winners",
      category: "Appreciations",
      date: "2024",
      issuer: "Bajaj Technology Services",
      description: "Recognized for outstanding commitment to continuous learning and professional development"
    },
    {
      id: 11,
      image: achivement1,
      title: "Deployment Star",
      category: "Achievements",
      date: "2024",
      issuer: "Bajaj Technology Services",
      description: "Acknowledged for excellence in deployment processes and DevOps practices"
    },
    {
      id: 12,
      image: achivement2,
      title: "Learning and Development Winners",
      category: "Achievements",
      date: "2024",
      issuer: "Bajaj Technology Services",
      description: "Award for exceptional growth and skill development"
    },
    {
      id: 13,
      image: achivement3,
      title: "Super Achiever",
      category: "Achievements",
      date: "2024",
      issuer: "Bajaj Technology Services",
      description: "Recognition for outstanding performance and contributions to team success"
    },
    {
      id: 14,
      image: achivement4,
      title: "Deployment Star",
      category: "Achievements",
      date: "2024",
      issuer: "Bajaj Technology Services",
      description: "Excellence in managing and executing critical deployment initiatives"
    },
];

export default Menu;
